(function () {
	'use strict';

	angular.module('app.supplyChain')
		.controller('crossSiteItemMaster', crossSiteItemMaster);

	function crossSiteItemMaster($scope, $timeout, URLS, crossSiteService, hostUrl, excelExportService, factorySettingService, $state, storeService) {
		var vm = this; // view model
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;
		$scope.useNewExport = true;
		vm.title = 'Cross site item data';
		vm.fields = ['Lead Time', 'MOQ', 'Proposed MOQ', 'Lot Size', 'EOQ', 'Order Interval', 'Unit Price', 'Standard Price', 'Last PO Price', 'Demand Variability', 'Safety Stock'];
		vm.additionalFields = ['Buyer', 'Supplier', 'Order Policy', 'UOM',
			'Company Defined Demand (Daily)', 'Past Demand (Daily)', 'Future Demand (Daily)',
			'On Hand Inventory', 'On Order Inventory', 'Excess Inventory'];
		var defaultFields = ['Lead Time'];
		vm.booleanValues = [{
			name: 'Yes',
			value: true
		},
		{
			name: 'No',
			value: false
		}
		];
		vm.daysDisplayTypes = [{
			name: 'Calendar Days',
			value: 'Calendar Days'
		},
		{
			name: 'Work Days',
			value: 'Work Days'
		}
		];
		vm.factories = [];
		vm.selected = {};
		vm.selected.factories = [];
		vm.selected.fields = defaultFields;
		vm.selected.additionalFields = [];
		vm.params = {};
		vm.pageLoaded = false;
		vm.reportName = 'Cross site item data';

		// scope functions
		vm.clearToast = clearToast;
		vm.clearErrorMessage = clearErrorMessage;
		vm.submit = submit;

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}

		vm.navigateToBaseReport = navigateToBaseReport;
		vm.baseReportDisplay = vm.reportName;

		if (reportSettingsId) {
			vm.showInfo = true;
		}

		function init() {
			getDropdownData();
		}

		function getDropdownData() {
			crossSiteService.getFactories().then(initForm);
		}

		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;
		if (reportSettingsId) {
			storeService.loadSavedView(globalConfig.factory.id, reportSettingsId, {}, {});

			var setTitle = function() {
				setTimeout(function() {
					if (vm.title = storeService.getState().reportSettings.reportName) {
						vm.title = storeService.getState().reportSettings.reportName;
					} else {
						setTitle();
					}
				}, 10);
			};
			setTitle();

		}

		function initForm(response) {
			vm.factories = response.data;
			vm.selected.factories = selectCurrentFactory();
			vm.selected.fields = defaultFields;
			vm.params.activeOnly = true;
			factorySettingService.getDaysDisplay(globalConfig.factory.id).then(function (response) {
				vm.params.daysDisplayType = response.daysDisplayType;
			});
			vm.params.multiFactoryOnly = true;
			vm.params.minDiff = 15;
			vm.params.fileName = 'crossSiteItemMaster';
		}

		function selectCurrentFactory() {
			var returnArray = [];
			for (var i = 0; i < vm.factories.length; i++) {
				if (globalConfig.factory.id == vm.factories[i].ndx) {
					returnArray.push(vm.factories[i]);
					// Select an additional factory - the first one that's not the current factory
					if (i == 0) {
						if (vm.factories.length > 1) {
							returnArray.push(vm.factories[1]);
						}
					} else {
						returnArray.push(vm.factories[0]);
					}
					return returnArray;
				}
			}
			return returnArray;
		}

		function clearToast() {
			vm.toastMessage = undefined;
		}
		$scope.addToastMessage = function (message) {
			vm.errorMessage = '';
			vm.toastMessage = message;
		};

		function clearErrorMessage() {
			vm.errorMessage = '';
		}
		$scope.addErrorToast = function (message) {
			vm.toastMessage = '';
			vm.errorMessage = message;
		};

		function getExcelReport() {
			var modalScope = $scope.$new();
			var url = String.format(URLS.host + urlPfx  + '/ExcelReports/CrossSiteItemMaster?', globalConfig.factory.id);
			url = encodeURI(url);
			url += jQuery.param(vm.params);
			url = appendQueryParam(url, 'crossSiteFndx', getCommaSeparatedFactoryList(vm.selected.factories));

			excelExportService.getExcelReportWithGet(getCommaSeparatedFactoryList(vm.selected.factories), url, modalScope, true, null, vm.params.fileName);
		}

		function getCommaSeparatedFactoryList(factories) {
			var commaSeparatedFactories = '';
			for (var i = 0; i < factories.length; i++) {
				commaSeparatedFactories += factories[i].ndx;
				if (i < factories.length - 1) {
					commaSeparatedFactories += ',';
				}
			}
			return commaSeparatedFactories;
		}

		function submit() {
			vm.params.fields = vm.selected.fields.join();
			vm.params.additionalFields = vm.selected.additionalFields.join();
			getExcelReport();
		}
		init();
	}
})();
